import { createFileRoute } from '@tanstack/react-router';
import { LocationCreatePage } from '@/features/locations/LocationCreatePage';

export const Route = createFileRoute('/app/board/new')({
  component: LocationCreatePage,
  staticData: { title: 'New site' },
});
